'use strict';

var App = App || {};

// Loading screen for all pages on load.
App.PageLoadingOverlay = function () {
  'use strict';

  var initialize = function initialize(args) {
    // If we are preloading a gallery, let that handle hiding the page preloading
    // if ($('.gallery-preload')) return false;

    _preloadPage();
  };

  var _preloadPage = function _preloadPage() {
    $("body, div, section").imagesLoaded({ background: true }, function () {
      $('body').removeClass("page-loading");
      $('.loading-overlay').velocity("fadeOut");
    });
  };

  return {
    initialize: initialize
  };
}();